import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'next-i18next'
import CountdownTimer from '../../../components/CountdownTimer'
import COLORS from '../../../styles/colors'

export type LiveCallMonitorEmptyStateProps = {
  nextReadingStart?: Date
}

const LiveCallMonitorEmptyState = ({
  nextReadingStart,
}: LiveCallMonitorEmptyStateProps) => {
  const { t } = useTranslation('LiveCallMonitor')

  return (
    <Stack spacing="12px" alignItems="center" textAlign="center" p="24px">
      <Typography variant="inter_h4">{t('emptyState.title')}</Typography>
      {nextReadingStart ? (
        <>
          <Typography variant="inter_bodyText" color={COLORS.grey}>
            {t('emptyState.nextReadingStartsIn')}
          </Typography>
          <Typography variant="inter_h4">
            <CountdownTimer date={nextReadingStart} />
          </Typography>
        </>
      ) : (
        <Typography variant="inter_bodyText" color={COLORS.grey}>
          {t('emptyState.noUpcomingReadings')}
        </Typography>
      )}
    </Stack>
  )
}

export default LiveCallMonitorEmptyState
